export const POSITION_QUERY_KEY = '/v2/positions-for-select' as const;
export const positionQueryKey = {
  all: [POSITION_QUERY_KEY] as const,
  list: (searchText: string) => [...positionQueryKey.all, {
    searchText
  }]
} as const;